
 import React, { Component } from 'react' 
 import { Route, Routes } from 'react-router-dom';
 import routes from './config/routes'
 export default class App extends Component {
    render() {  
      return  <div className="App"> 
          <Routes>
              {
                routes.map((item,index)=>{
                  return <Route key={index}  {...item}/>
                })
              }
          </Routes> 
      </div> 
  }
}
